export class GiftCardActivationModel {
    constructor(
        public number: string, 
        public cardOperationId: string = '', 
        public value?: number,
        public confirmed: boolean = false,
        public canActivate: boolean = null
        ) { }
}